export const createPosthogOptions = (token) => ({
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    defaults: '2025-05-24',
    person_profiles: 'never',
    // Never reuse an ID already linked to a person, even on the first pageview.
    // Keep this namespace stable across releases. Consent still uses the project token.
    persistence_name: `aleta_anonymous_v1_${token}`,
    autocapture: false,
});
